import React from 'react'
import Button from '@material-ui/core/Button';

import { NavLink } from 'react-router-dom'
import withStyles from '@material-ui/core/styles/withStyles';
import './ticket.css'

// import Icon from '@material-ui/core/Icon';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Icon from '@material-ui/core/Icon';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import CheckBox from './../FormComponent/CheckBox';


const styles = theme => ({
  root: {
    flexGrow: 1,
    flexDirection: 'column',

  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
  },
  details: {
    flexDirection: 'column'
  },
  icon: {
    color: 'red'
  },
  button: {
    margin: theme.spacing.unit,
  },
  leftIcon: {
    marginRight: theme.spacing.unit,
  },
  rightIcon: {
    marginLeft: theme.spacing.unit,
  },
  iconSmall: {
    fontSize: 20,
  },
});

function Ticket(props) {

  const { item } = props;
  const { classes } = props;
  if (!item) {
    return null
  }
  if (!props.type || !props.model || !props.producer || !props.status) {
    return null
  }

  return (
    < ExpansionPanel >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>

        <div className="ticket__group-items">
          <div className="ticket__group-item ticket__group-item-icon">
            <Icon className="material-icons" style={{ color: `${props.status[0].color}` }}>{props.status[0].icon}</Icon>
          </div>
          <div className="ticket__group-item ticket__group-item-a ">
            <div className="group__item-status">
              <div>{props.status[0].name}</div>
            </div>
          </div>
          <div className="ticket__group-item ticket__group-item-b">{props.type[0].name}</div>
          <div className="ticket__group-item ticket__group-item-b">{props.model[0].name}</div>
          <div className="ticket__group-item ticket__group-item-b">{item.created_at}</div>
          <div className="ticket__group-item ticket__group-item-icon">
            <CheckBox id={item.id} is_document={item.is_document} />
          </div>
        </div>


      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={classes.details}>

        <div className="ticket__details">
          <div className="ticket__details-technics">
            <div className="ticket__details-header">Техніка</div>
            <div className="ticket__details-content">
              <div className="content__item">
                <div className="content__item-title">Тип</div>
                <div className="content__item-info">{props.type[0].name}</div>
              </div>
              <div className="content__item">
                <div className="content__item-title">Модель</div>
                <div className="content__item-info">{props.model[0].name}</div>
              </div>
              <div className="content__item">
                <div className="content__item-title">Виробник</div>
                <div className="content__item-info">{props.producer[0].name}</div>
              </div>
              <div className="content__item">
                <div className="content__item-title">Серійний номер</div>
                <div className="content__item-info">{props.series}</div>
              </div>
            </div>
          </div>
          <div className="ticket__details-departament">
            <div className="ticket__details-header">Підрозділ ДМС</div>
            <div className="ticket__details-content">
              <div className="content__item">
                {item.dep.code} - {item.dep.name}
              </div>
            </div>
          </div>
        </div>

        <div className='ticket__text'>{(item.description.length !== 0) ? item.description : 'Заявка без коментаря'}</div>
        <NavLink to={`/tickets/${item.id}`} style={{ textDecoration: 'none', display: 'flex', flexDirection: 'column' }}>
          <Button variant="contained" color="primary" className={classes.button} style={{ maxWidth: '400px', alignSelf: 'flex-end' }}>
            Детальніше
            <Icon className={classes.rightIcon}>call_made</Icon>
          </Button>
        </NavLink>
      </ExpansionPanelDetails>
    </ExpansionPanel >


  )
}

export default withStyles(styles)(Ticket);


// WEBPACK FOOTER //
// ./src/components/Ticket/Ticket.js